import React, {useRef, useState} from "react";
import s from "./ImageUpload.module.css";
import Cropper from "react-easy-crop";

type CropImageProps={
    image:string
    setCroppedAreaPixels:(croppedAreaPixels:any)=>void
}
const CropImage : React.FC<CropImageProps>= ({image,setCroppedAreaPixels}) => {

    const cropperRef = useRef<HTMLImageElement | null>(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [aspect, setAspect] = useState<number | undefined>(4 / 3);


    const onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };


    return (
        <div className={s.cropper_container}>

            <div className={s.cropper}>
                <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    aspect={aspect}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                />

            </div>
            <div className={s.aspect_buttons}>
                <button
                    className={`${s.button} ${aspect === 1 ? s.active : ""}`}
                    onClick={() => setAspect(1)}
                >
                    1:1
                </button>
                <button
                    className={`${s.button} ${aspect === 4 / 3 ? s.active : ""}`}
                    onClick={() => setAspect(4 / 3)}
                >
                    4:3
                </button>
                <button
                    className={`${s.button} ${aspect === 16 / 9 ? s.active : ""}`}
                    onClick={() => setAspect(16 / 9)}
                >
                    16:9
                </button>
                <button
                    className={`${s.button} ${aspect === 3 / 2 ? s.active : ""}`}
                    onClick={() => setAspect(3 / 2)}
                >
                    3:2
                </button>
            </div>
        </div>
    )
}
export default CropImage;